import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../api/client';

export default function SlackCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = params.get('code');
    const state = params.get('state');

    if (!code || !state) {
      setError('Missing OAuth parameters. Please try connecting Slack again.');
      return;
    }

    let cancelled = false;

    api.completeSlackOAuth(code, state)
      .then((result) => {
        if (cancelled) return;
        if (result.ok) {
          navigate('/settings', { replace: true });
        } else {
          setError(result.error || 'Slack connection failed. Please try again.');
        }
      })
      .catch((err: Error) => {
        if (cancelled) return;
        setError(err.message || 'Slack connection failed. Please try again.');
      });

    return () => {
      cancelled = true;
    };
  }, [params, navigate]);

  if (error) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          gap: 'var(--sp-4)',
          padding: 'var(--sp-6)',
        }}
      >
        <p
          style={{
            color: 'var(--color-text-error-default)',
            fontSize: '14px',
            textAlign: 'center',
            maxWidth: '360px',
          }}
        >
          {error}
        </p>
        <button
          onClick={() => navigate('/settings', { replace: true })}
          style={{
            padding: 'var(--sp-2) var(--sp-4)',
            borderRadius: 'var(--radius-md)',
            border: '1px solid var(--color-border-neutral-subtle-default)',
            background: 'var(--color-surface-neutral-default)',
            color: 'var(--color-text-neutral-default)',
            fontSize: '14px',
            cursor: 'pointer',
          }}
        >
          Back to Settings
        </button>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <div
        className="w-[32px] h-[32px] border-[3px] rounded-full animate-spin"
        style={{
          borderColor: 'var(--color-border-neutral-subtle-default)',
          borderTopColor: 'var(--color-surface-action-strong-default)',
        }}
      />
    </div>
  );
}
